import { useState, useCallback } from "react";
import { useWallet } from "@solana/wallet-adapter-react";
import { useGetAccountInfo } from "@/hooks/sdkDappHooks";
import { NetworkType, WalletConnectionState } from "./types";

export const useBridgeWallet = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [onConnectionComplete, setOnConnectionComplete] = useState<
    (() => void) | null
  >(null);

  // Wallet connections
  const { connected: solanaConnected } = useWallet();
  const { address: mvxAddress } = useGetAccountInfo();

  const walletStates: WalletConnectionState = {
    solana: solanaConnected,
    multiversx: !!mvxAddress,
  };

  const checkConnectionsAndPrompt = useCallback(
    (requiredNetworks: NetworkType[]): boolean => {
      const missingConnections = requiredNetworks.filter(
        (network) => !walletStates[network]
      );

      if (missingConnections.length > 0) {
        setIsModalOpen(true);
        return false;
      }

      return true;
    },
    [walletStates]
  );

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setOnConnectionComplete(null);
  }, []);

  const handleAllConnected = useCallback(() => {
    if (onConnectionComplete) {
      onConnectionComplete();
    }
  }, [onConnectionComplete]);

  return {
    isModalOpen,
    walletStates,
    checkConnectionsAndPrompt,
    closeModal,
    handleAllConnected,
  };
};
